import { Grid, Paper } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { Animated } from 'react-animated-css';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Url from 'url';
import join from 'url-join';
import { ApiServerUrl } from '../config.json';
import { withLang } from '../util/lang';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { getWebAbsPath } from '../util/path';
import DoctorAppSetting from '../components/MobileApp/DoctorAppSetting';
import Banner from '../components/Banner';

const styles = (theme) => ({
    root: {
        margin: '48px auto',
        [theme.breakpoints.down('sm')]: {
            margin: '0 auto',
        },
        [theme.breakpoints.up('lg')]: {
            width: '70%',
        },
    },
    devicesContainer: {
        padding: 16,
        background: '#f2f2f2',
        [theme.breakpoints.down('sm')]: {
            padding: 0,
        },
    },
});

class AppSetting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userId: this.props.match.params.id
                ? this.props.match.params.id
                : JSON.parse(localStorage.getItem('auth-token')),
        };
    }

    render() {
        const { classes } = this.props;
        return (
            <Animated animationIn="fadeIn" isVisible={true}>
                <Grid container className={classes.devicesContainer}>
                    <Grid item xs={12}>
                        <Banner />
                    </Grid>
                </Grid>

                <Grid container>
                    <Grid item xs={12} md={12} style={{ padding: '24px 16px 24px 8px' }}>
                        <Paper>
                            <DoctorAppSetting user_id={this.state.userId} />
                        </Paper>
                    </Grid>
                </Grid>
            </Animated>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        lang: store.lang,
        config: store.config.config,
    };
};

export default connect(mapStateToProps)(withStyles(styles)(withRouter(withLang(AppSetting, 'AppSetting'))));
